import React, { FC } from 'react';
import './styles.scss';

const CarouselDots: FC = () => <div className="slick-dots__item"></div>;

export default CarouselDots;
